module.exports = __webpack_public_path__ + "static/media/COMM.a58c75f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/COMM.jpg
// module id = 1720
// module chunks = 1